<div class="px-6 py-4">
  <form nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
    <nz-form-item>
      <nz-form-label [nzRequired]="true" nzFor="hospitalId">საავადმყოფოს ID</nz-form-label>
      <nz-form-control [nzErrorTip]="'აუცილებელია'">
        <input nz-input formControlName="hospitalId" id="hospitalId" placeholder="შეიყვანეთ საავადმყოფოს ID" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzRequired]="true" nzFor="password">EHR პაროლი</nz-form-label>
      <nz-form-control [nzErrorTip]="'აუცილებელია'">
        <input nz-input type="password" formControlName="password" id="password" placeholder="შეიყვანეთ პაროლი" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzRequired]="true" nzFor="ehrPrefix">EHR პრეფიქსი</nz-form-label>
      <nz-form-control [nzErrorTip]="'აუცილებელია'" [nzExtra]="extraTemplate">
        <input nz-input formControlName="ehrPrefix" id="ehrPrefix" placeholder="შეიყვანეთ EHR პრეფიქსი" />
      </nz-form-control>
      <ng-template #extraTemplate>
        <div class="flex flex-col gap-2 text-sm text-gray-500">
          <div>EHR პრეფიქსი უნდა შეიცავდეს მხოლოდ ასოებს</div>
          <div>
            EHR პრეფიქსი განკუთვნილია EHR ნომრის დასაწყისში გამოყენებისთვის, მაგალითად: <strong>EHR-</strong>
          </div>
          <div>
            EHR ნომერი იქნება ფორმატში: <strong>EHR-1-202505-000001</strong>,
          </div>
          <ul class="list-disc pl-5">
            <li><strong>1</strong> არის საავადმყოფოს ID</li>
            <li><strong>202505</strong> არის თარიღი (წელი და თვე)</li>
            <li><strong>000001</strong> არის უნიკალური სერიული ნომერი</li>
          </ul>
        </div>
      </ng-template>
    </nz-form-item>
  </form>

  @if (organization()) {
    <div class="mt-4 p-4 bg-gray-50 rounded-md">
      <h3 class="text-lg font-medium mb-2">ორგანიზაციის ინფორმაცია</h3>
      <div>{{ organization().legalName }}</div>
      <div>{{ organization().legalAddress }}</div>
    </div>
  }
</div>


<div *nzModalFooter>
  <button nz-button nzType="default" type="button" (click)="modalRef.triggerCancel()">
    გაუქმება
  </button>
  <button nz-button nzType="primary" (click)="onSubmit()" [disabled]="form.invalid" type="submit">
    {{clinicInfo() ? 'შენახვა' : 'აქტივაცია'}}
  </button>
</div>
